import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles, featuredComics } from '@/mocks/data';

const articleCovers: Record<string, string> = {
  'article-cover-01': 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20colorful%20comic%20reading%20app%2C%20cozy%20reading%20nook%20with%20warm%20lighting%2C%20minimalist%20composition%2C%20soft%20shadows%2C%20natural%20warm%20tones%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=article-cover-01&orientation=landscape',
  'article-cover-02': 'https://readdy.ai/api/search-image?query=Smartphone%20with%20download%20icon%20and%20colorful%20comic%20art%2C%20warm%20ambient%20lighting%2C%20cozy%20home%20environment%2C%20minimalist%20modern%20design%2C%20clean%20composition%2C%20soft%20warm%20colors&width=800&height=500&seq=article-cover-02&orientation=landscape',
  'article-cover-03': 'https://readdy.ai/api/search-image?query=Global%20map%20with%20colorful%20comic%20style%20cultural%20elements%2C%20warm%20ambient%20lighting%2C%20vibrant%20illustration%2C%20modern%20digital%20art%2C%20clean%20composition%2C%20professional%20aesthetic&width=800&height=500&seq=article-cover-03&orientation=landscape',
  'article-cover-04': 'https://readdy.ai/api/search-image?query=Colorful%20top%2010%20ranking%20list%20with%20comic%20book%20covers%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20design%2C%20minimalist%20composition%2C%20soft%20shadows%2C%20professional%20aesthetic&width=800&height=500&seq=article-cover-04&orientation=landscape',
  'article-cover-05': 'https://readdy.ai/api/search-image?query=Android%20phone%20with%20APK%20installation%20screen%20and%20comic%20art%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20design%2C%20modern%20tech%20aesthetic%2C%20soft%20shadows&width=800&height=500&seq=article-cover-05&orientation=landscape',
  'article-cover-06': 'https://readdy.ai/api/search-image?query=Korean%20drama%20and%20comic%20crossover%20concept%20art%2C%20warm%20cinematic%20lighting%2C%20elegant%20composition%2C%20modern%20digital%20art%2C%20professional%20aesthetic%2C%20clean%20background&width=800&height=500&seq=article-cover-06&orientation=landscape',
};

const coverImages: Record<string, string> = {
  'comic-cover-01': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20cover%20art%2C%20beautiful%20romance%20couple%20illustration%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20cover%2C%20vibrant%20warm%20colors%2C%20artistic%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
  'comic-cover-02': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20sword%20warrior%20in%20magical%20world%2C%20dramatic%20lighting%2C%20clean%20background%2C%20modern%20digital%20illustration%2C%20professional%20comic%20style%2C%20vibrant%20warm%20tones&width=600&height=800&seq=comic-cover-02&orientation=portrait',
  'comic-cover-03': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20martial%20arts%20fighter%20dynamic%20pose%2C%20intense%20dramatic%20lighting%2C%20clean%20minimal%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20cover%2C%20vibrant%20colors&width=600&height=800&seq=comic-cover-03&orientation=portrait',
  'comic-cover-04': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20funny%20office%20workers%20illustration%2C%20bright%20cheerful%20lighting%2C%20clean%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20style%2C%20warm%20playful%20colors&width=600&height=800&seq=comic-cover-04&orientation=portrait',
  'comic-cover-05': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%2C%20mysterious%20dark%20atmosphere%2C%20suspenseful%20illustration%2C%20dim%20lighting%2C%20clean%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20cover%2C%20moody%20tones&width=600&height=800&seq=comic-cover-05&orientation=portrait',
  'comic-cover-06': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20emotional%20character%20portrait%20in%20cozy%20cafe%2C%20warm%20nostalgic%20lighting%2C%20clean%20background%2C%20modern%20digital%20illustration%2C%20professional%20comic%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
  'comic-cover-07': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%2C%20group%20of%20teenage%20friends%20illustration%2C%20bright%20sunny%20lighting%2C%20clean%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20cover%2C%20fresh%20youthful%20colors&width=600&height=800&seq=comic-cover-07&orientation=portrait',
  'comic-cover-08': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20cover%2C%20elegant%20two%20male%20characters%20in%20moonlight%2C%20soft%20romantic%20lighting%2C%20clean%20background%2C%20modern%20digital%20art%2C%20professional%20comic%20style%2C%20beautiful%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
};

type ContentItem = {
  id: number;
  title: string;
  summary?: string;
  content?: string;
  description?: string;
  category?: string;
  categoryName?: string;
  date?: string;
  readCount?: number;
  author?: string;
  coverSeq?: string;
  rating?: number;
  chapters?: number;
  status?: string;
};

function getArticleById(id: number): ContentItem | null {
  const article = articles.find((a) => a.id === id);
  if (article) return article as unknown as ContentItem;

  const comic = featuredComics.find((c) => c.id === id);
  if (comic) return comic as unknown as ContentItem;

  return null;
}

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const articleId = Number(id);
  const article = getArticleById(articleId) as (typeof articles)[0] | null;
  const isComic = featuredComics.some((c) => c.id === articleId);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        {article ? (
          <>
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                ...(isComic
                  ? [{ label: '分类浏览', path: '/category' }]
                  : []),
                { label: article.title },
              ]}
            />

            <article className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12">
              <header className="mb-8">
                <div className="flex items-center gap-3 mb-4">
                  {article.categoryName && (
                    <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                      {article.categoryName}
                    </span>
                  )}
                  {article.date && (
                    <span className="text-sm text-foreground-400">
                      {article.date}
                    </span>
                  )}
                </div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
                  {article.title}
                </h1>
                <div className="flex items-center gap-4 text-sm text-foreground-500">
                  {article.author && <span>作者：{article.author}</span>}
                  {article.readCount && (
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line w-4 h-4 flex items-center justify-center"></i>
                      {article.readCount.toLocaleString()} 阅读
                    </span>
                  )}
                  {article.chapters && (
                    <span className="flex items-center gap-1">
                      <i className="ri-book-read-line w-4 h-4 flex items-center justify-center"></i>
                      {article.chapters}话
                    </span>
                  )}
                  {article.rating && (
                    <span className="flex items-center gap-1 text-yellow-500">
                      <i className="ri-star-fill w-4 h-4 flex items-center justify-center"></i>
                      {article.rating}
                    </span>
                  )}
                </div>
              </header>

              {article.coverSeq && (
                <div className="aspect-[16/9] md:aspect-[21/9] rounded-xl overflow-hidden mb-8">
                  <img
                    src={
                      isComic
                        ? coverImages[article.coverSeq]
                        : articleCovers[article.coverSeq]
                    }
                    alt={article.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              )}

              {article.content ? (
                <div
                  className="prose prose-sm md:prose-base max-w-none text-foreground-800 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: article.content }}
                />
              ) : article.description ? (
                <div className="text-foreground-700 leading-relaxed text-sm md:text-base space-y-4">
                  <p>{article.description}</p>
                  <div className="bg-background-100 rounded-xl p-6 mt-8">
                    <h3 className="font-heading font-bold text-foreground-900 mb-3">
                      作品信息
                    </h3>
                    <div className="grid grid-cols-2 gap-3 text-sm">
                      <div>
                        <span className="text-foreground-500">
                          状态：
                        </span>
                        <span className="text-foreground-900 font-medium">
                          {article.status}
                        </span>
                      </div>
                      <div>
                        <span className="text-foreground-500">
                          章节：
                        </span>
                        <span className="text-foreground-900 font-medium">
                          {article.chapters}话
                        </span>
                      </div>
                      <div>
                        <span className="text-foreground-500">
                          评分：
                        </span>
                        <span className="text-foreground-900 font-medium">
                          {article.rating}/10
                        </span>
                      </div>
                      <div>
                        <span className="text-foreground-500">
                          分类：
                        </span>
                        <span className="text-foreground-900 font-medium">
                          {article.categoryName}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-4 mt-8">
                    <Link
                      to="/article/5"
                      className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
                      下载韩漫APK
                    </Link>
                    <Link
                      to="/article/2"
                      className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 text-sm font-medium rounded-full hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-guide-line w-4 h-4 flex items-center justify-center"></i>
                      离线下载指南
                    </Link>
                  </div>
                </div>
              ) : null}
            </article>

            <section className="py-12 bg-background-100">
              <div className="max-w-4xl mx-auto px-4 md:px-6">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-6">
                  相关推荐
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {featuredComics
                    .filter((c) => c.id !== articleId)
                    .slice(0, 4)
                    .map((comic) => (
                      <Link
                        key={comic.id}
                        to={`/article/${comic.id}`}
                        className="group bg-background-50 rounded-xl overflow-hidden hover:shadow-md transition-all duration-300 cursor-pointer border border-background-200/70"
                      >
                        <div className="aspect-[3/4] overflow-hidden">
                          <img
                            src={coverImages[comic.coverSeq]}
                            alt={comic.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                          />
                        </div>
                        <div className="p-3">
                          <h4 className="text-xs font-semibold text-foreground-900 line-clamp-1">
                            {comic.title}
                          </h4>
                        </div>
                      </Link>
                    ))}
                </div>
              </div>
            </section>
          </>
        ) : (
          <section className="max-w-4xl mx-auto px-4 md:px-6 py-20 text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
            </div>
            <h1 className="text-xl font-heading font-bold text-foreground-900 mb-3">
              文章未找到
            </h1>
            <p className="text-foreground-500 mb-8">
              抱歉，您访问的内容不存在或已被移除。
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
              返回首页
            </Link>
          </section>
        )}
      </main>
      <Footer />

      {article && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Article',
              headline: article.title,
              description: article.summary || article.description || '',
              datePublished: article.date || '2025-01-01',
              author: {
                '@type': 'Person',
                name: article.author || '韩漫之家编辑',
              },
              breadcrumb: {
                '@type': 'BreadcrumbList',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'https://hanmanzhijia.com/',
                  },
                  ...(isComic
                    ? [
                        {
                          '@type': 'ListItem' as const,
                          position: 2,
                          name: '分类浏览',
                          item: 'https://hanmanzhijia.com/category',
                        },
                      ]
                    : []),
                  {
                    '@type': 'ListItem' as const,
                    position: isComic ? 3 : 2,
                    name: article.title,
                  },
                ],
              },
            }),
          }}
        />
      )}
    </>
  );
}